export const getTicketNumberStatus = (state) => {
  return state.ticketNumberStatus;
};

export const getTicketNumberObject = (state) => {
  const { ticketNumberObject } = getTicketNumberStatus(state);
  return ticketNumberObject;
};

export const getTicketNumberId = (state) => {
  const { id } = getTicketNumberObject(state);
  return (id) || null;
};
